const getTendersByProjectReq = {
  projectID: '',
};

export default getTendersByProjectReq;
